<div class="m-t-16 m-b-16">
<div class="{{backgroundClass}} notification-container">
  <div *ngIf="closable" style="margin-top:-1em">
    <div (click)="emitDismissal.emit()" class="text-right addCursor">
      <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3.5" cy="3.5" r="3.5" fill="#E94444"/>
      </svg>
    </div>
  </div>
  <div nz-row nzAlign="middle" nzJustify="space-between">
    <div nz-row nzAlign="middle">
   <div>
   <app-blue-icons *ngIf="notificationType === 'transparent-info'" blueIcon="blue-notification-info">
    </app-blue-icons>
     <app-blue-icons *ngIf="notificationType === 'info'" blueIcon="blue-notification-info">
     </app-blue-icons>
     <app-blue-icons *ngIf="notificationType === 'error'" blueIcon="blue-notification-error">
     </app-blue-icons>
     <app-blue-icons *ngIf="notificationType === 'warning'" blueIcon="blue-notification-warning">
    </app-blue-icons>
    </div>
    <div>
        <div class="notification-content-width">
          <div class="notification-title">
            {{title}}
          </div>
          <div class="notification-message">
            {{message}}
          </div>
        </div>
      </div>
    </div>
    <div>
      <div *ngIf="canPerformAction" class="web-action-btn">
        <div (click)="emitNotificationAction.emit()"
        class="notification-action-btn {{notificationType === 'error'?'notification-error-color':'notification-info-color '}} addCursor">
       {{actionName}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="canPerformAction" class="m-t-15 mobile-action-btn">
    <div nz-row nzAlign="middle" nzJustify="space-between">
      <div></div>
      <div>
        <div nz-row nzAlign="middle">
          <div *ngIf="closable">
            <div (click)="emitDismissal.emit()" class="notification-dismiss-btn addCursor">
             {{dismissButtonName}}
            </div>
          </div>
          <div>
            <div class="{{closable?'m-l-27':''}}">
              <div (click)="emitNotificationAction.emit()" class="notification-action-btn {{notificationType === 'error'?'notification-error-color':'notification-info-color '}} addCursor">
                {{actionName}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

